<template>
	<div  class="function_wrap" id='function_wrap'>

		<!-- <img src="@/assets/images/ads/dayscal.png" alt="天数计算器"  class="hidden_img"   > -->

		<div  :class=" !isPhone? 'function_wrap box':'function_wrap box_mobile' " id='function_box0'>
			<!-- <div class="function_wrap_title">录音转文字</div> -->
			<h1 class="function_wrap_title">录音转文本</h1>
			<!-- <div class="function_wrap_title_EN">INTEREST CALCULATOR</div> -->
			
			<div class='optionitem'  style="margin-top:40px">   
				<div class="optionitem item_name" >场景选择：</div>
				<div class="optionitem item_detail">
					<el-select   v-model="scen_type"    @change="ChangeModelType" placeholder="请选择" style="width:80%">
						<!-- <el-option
						v-for="item in modelTypes"
						:key="item.value"
						:label="item.label"
						:value="item.value">
						</el-option> -->
						<el-option	label="电话通讯" :value="0"  >	</el-option>
						<el-option	label="通用场景" :value="1" >	</el-option>

					</el-select>	
			 
			 
					
				</div> 
				

			 

			</div>  
   			<!-- <div  style="width:100%; padding-right:20px"> 
				<span style="float:right;">场景选错会影响转换准确率</span>	   
			</div> -->
			<div style="width:100%">
				<!-- <span  class="guide" @click="CheckDemo">查看word报告模板</span> -->
				<a  style="margin-left:40px; "   class="guide">   
					注意（重要）：场景选错会影响转换准确率，非电话场景请选择通用场景
				</a> 

				<!-- <span  class="guide" @click="CheckDemo">查看案例模板</span> -->

			</div> 

			<div v-if="scen_type==0" class='optionitem'  style="margin-top:10px">   
				<div class="optionitem item_name" >模型：</div>
				<div class="optionitem item_detail">
					<el-select   v-model="modelType" placeholder="请选择" style="width:80%">
						<el-option
						v-for="item in modelTypes1"
						:key="item.value"
						:label="item.label"
						:value="item.value">
						</el-option>
					</el-select>	
			 
					
				</div> 

			 

			</div>  

		 

			<div v-if="scen_type==1" class='optionitem'  style="margin-top:10px">   
				<div class="optionitem item_name" >场景选择：</div>
				<div class="optionitem item_detail">
					<el-select   v-model="modelType" placeholder="请选择" style="width:80%">
						<el-option
						v-for="item in modelTypes2"
						:key="item.value"
						:label="item.label"
						:value="item.value">
						</el-option>
					</el-select>	
			 
					
				</div> 

			 

			</div>  




			<div class="fangyan" v-if="modelType=='16k_zh_dialect'">
				<p>目前支持的方言：上海话、四川话、武汉话、贵阳话、昆明话、西安话、郑州话、太原话、兰州话、银川话、
					西宁话、南京话、合肥话、南昌话、长沙话、苏州话、杭州话、济南话、天津话、石家庄话、黑龙江话、吉林话、辽宁话</p>


			</div>

			<div class='optionitem'  style="margin-top:25px" v-if="scen_type==1">   
				<div class="optionitem item_name" >是否开启话者分离</div>
				<div class="optionitem item_detail">
	 
					<el-select   v-model="SpeakerDiarization" placeholder="请选择" style="width:80%">
						<el-option	label="是" value='1' >	</el-option>
						<el-option	label="否" value='0' >	</el-option>

					</el-select>	
					
				</div> 

			</div>  


			<div class='optionitem'  style="margin-top:25px" v-if="SpeakerDiarization==1 && scen_type==1 ">   
				<div class="optionitem item_name" >分离人数</div>
				<div class="optionitem item_detail">
					
			 
					<el-select  v-model="SpeakerNumber" placeholder="请选择" style="width:80%">
						<el-option
						v-for="item in numbers"
						:key="item"
						:label="item"
						:value="item">
						</el-option>
					</el-select>	
					
				</div> 

			</div>




			<!-- old version -->
			<!-- <el-upload
				class="upload-demo"
				drag
				action="https://api.lawtip.cn/sound2txt_upload"
				multiple
				accept=".wav,.flac,.opus,.m4a,.mp3,.amr"
				:limit="1"
				with-credentials
				:data="uploadData"
				:on-success="handleUploadSuccess"
				:file-list="file_list"
				:before-upload="handleUploadbefore"  >
				<i class="el-icon-upload"></i>
				<div class="el-upload__span">将文件拖到此处，或<em>点击上传</em></div>
				<div class="el-upload__tip" slot="tip">暂支持的音频格式有：'wav','flac','opus','m4a','mp3','amr'等。</div>
			</el-upload> -->
			<!-- old version -->

<!-- with-credentials -->
<!-- .wav,.flv,.mp4,.m4a,.mp3, .amr -->

			<el-dialog
				title="下载地址"
				:visible.sync="taskDialogVisible"
				width="30%"
				center>
				<span>{{task_downloadlink}} </span>
				<span slot="footer" class="dialog-footer">
					<el-button @click="DownLoadTask(task_downloadlink)"  style="margin-right:40px" >直接下载</el-button>
					<el-button type="primary" @click="taskDialogVisible = false" >确 定</el-button>
				</span>
			</el-dialog>

	 		<div class="upload_wrap">
				<div class="left_box">  
					<span>处理列表</span>
					<div class="reuslt_bar"  style="margin-top:10px" >
						<div class="res_item" style="width:10%;"> 序号 </div>
						<div class="res_item"  style="width:65%">文件名</div>
						<div class="res_item"  style="width:20%">是否完成</div>
		 
					</div>

					<div   style="width:100%"> 
						<div  class="reuslt_bar" v-for="(item,index ) of process_list"  v-bind:key="item._id" >
							<div class="res_item" style="width:10%;"> {{index+1}} </div>
							<div class="res_item"  style="width:65%">{{item.fileName}}</div>
							<!-- <div class="res_item"  style="width:20%">{{item.isDone? "是。查看链接":"否"}} </div> -->
							<div v-if="!item.isDone" class="res_item"  style="width:20%"><i class="el-icon-loading"></i></div>
							<div v-else class="res_item" @click="CheckItemDetail(item.downLoadLink)" style="width:20%;color:blue;cursor:pointer">查看下载链接</div>

 
						</div>
					</div>

				</div>

			 

		 

				<div class="right_box">
					<el-upload
						class="upload-demo"
						drag
						action="https://lawassist.oss-cn-hangzhou.aliyuncs.com"
						:multiple='false'
						accept=".wav,.flv,.mp4,.m4a,.mp3,.amr,.WAV,.FLAC,.flac,.OPUS,.M4A',.MP3,.AMR,.MP4,.FLV,.wma,.WMA,.3gp,.3GP,.aac,.AAC,.ogg-opus"
						:limit="2"
						:http-request="UpLoadFilesHandle"
						:data="uploadData"
						:on-success="handleUploadSuccess"
						:file-list="file_list"
						:before-upload="handleUploadbefore" 
						:on-progress="handleUploadProgress"
						:on-remove="handleRemoveFile"
						>
						<i class="el-icon-upload"  ></i>
						<div class="el-upload__span" >将文件拖到此处，或<em>点击上传</em></div>
						<div class="el-upload__tip" slot="tip">
							<p>暂支持的音频格式有：wav、mp3、m4a、flv、mp4、wma、3gp、amr、aac、ogg-opus、flac。</p>
							<p>收费方式：0.08法币/分钟，会员0.04/分钟。上传后需根据文件大小按照0.08/M（会员0.04/M）先支付法币押金，<span style="color:red">请保证上传文件前法币余额充足。</span>  结果生成后，根据分钟多退少补，向上取分钟整数。</p>
							<p>非实时转换，限制文件大小500M。操作后，请过一会儿再查看记录，最快五分钟内出结果。如果超过1小时没有出结果，请咨询客服微信:dfc0829 </p>
							<p>本功能由腾讯AI训练实现，随着训练的加深，效果会不断提升。</p>

						</div>
					</el-upload>


					<div style="width:25%;height:50px;margin-top:20px">

						<el-progress :text-inside="true" :stroke-width="24" :percentage="uploadPercent" status="success"></el-progress> 
						<!-- <p style="font-size:14px">文件尚未上传处理完毕，请稍等</p> -->
					</div>
	 
					<!-- $state.store.isLogin -->
					<el-button v-if="$store.state.islogin" :type="uploadSig==true? 'info': 'primary'" :disabled="uploadSig"   style="margin-top:25px;min-width:160px" @click="start_tran">
						{{uploadSig==true? '文件尚未上传处理完毕，请稍等': '开始转换' }}
						<!-- 开始转换 -->
						
					</el-button>

					<el-button v-else type="info" disabled style="margin-top:25px;width:160px"  >请先登录</el-button>

				</div>
			</div>


			<!-- <el-upload
				class="upload-demo"
				drag
				action="https://lawassist.oss-cn-hangzhou.aliyuncs.com"
				:multiple='false'
				accept=".wav,.flv,.mp4,.m4a,.mp3,.amr"
				:limit="2"
				:http-request="UpLoadFilesHandle"
				:data="uploadData"
				:on-success="handleUploadSuccess"
				:file-list="file_list"
				:before-upload="handleUploadbefore" 
				:on-progress="handleUploadProgress"
				:on-remove="handleRemoveFile"
				>
				<i class="el-icon-upload"></i>
				<div class="el-upload__span">将文件拖到此处，或<em>点击上传</em></div>
				<div class="el-upload__tip" slot="tip">暂支持的音频格式有：'wav','flv','mp4','m4a','mp3','amr'。</div>
			</el-upload>


			<div style="width:25%;height:50px;margin-top:20px">

				<el-progress :text-inside="true" :stroke-width="24" :percentage="uploadPercent" status="success"></el-progress>
			</div>
	 

			<el-button type="primary" style="margin-top:40px;width:160px" @click="start_tran">开始转换</el-button> -->

			<div class="history_button"> 
				<div style="float:right">
					<span>上传前请务必保证您账户有法币余额。我的法币余额： {{ $store.state.accountInfo.coins }} </span>

					<el-button type="info" style="margin-left:20px" @click="Go2Deposit">充值</el-button>
				</div>
		
			</div>

			<div class="history_button">
			 
				<el-button  type="warning" style="float:right" @click="CheckHistory(1)">查看/刷新 记录</el-button>

			</div>

			<div class="history_bar"   >
				<span> 我的记录</span>
			</div>

			<div class="reuslt_bar"   v-if="showHistroy" >
				<div class="res_item" style="width:7%;"> 序号 </div>
				<div class="res_item"  style="width:23%">文件名</div>
				<div class="res_item"  style="width:45%">下载链接 </div>
				<div class="res_item"  style="width:8%">是否完成</div>
				<div class="res_item"  style="width:8.5%">时间 </div>
				<div class="res_item"  style="width:7.5%"> 消耗法币</div>
			</div>

			<div v-if="showHistroy" style="width:100%"> 
				<div  class="reuslt_bar" v-for="(item,index ) of list"  v-bind:key="item._id" >
					<div class="res_item" style="width:7%;"> {{index+1}} </div>
					<div class="res_item"  style="width:23%">{{item.fileName}}</div>
					<div class="res_item"  style="width:45%"> 
						<a  style="font-size:16rpx;padding-left:2px;padding-right:2px;text-decoration:underline;cursor:pointer" @click="DownLoadTask(item.downLoadLink)">{{item.downLoadLink}}</a> 
						<!-- :href="item.downLoadLink" -->
					</div>
					<div class="res_item"  style="width:8%">{{item.isDone? "是":"否"}} </div>
					<div class="res_item"  style="width:8.5%"> {{ fermitTime(item.time)}}</div>
					<div class="res_item"  style="width:7.5%"> {{item.cost}}</div>
				</div>
			</div>

			<div class="bottom">
                <!-- <div class="bottom right">
                    <Pages :pageTotal="mypages" :pageSize="20"  @ChangePage="ChangeListPage"></Pages>

                </div> -->
				<Pages :pageTotal="totalRecord" :pageSize="10"  @ChangePage="ChangeListPage"  style="padding-right:5px;  text-align:right;" ></Pages>
                <!-- <a href="javascript:void(0)" @click="open_blank"></a> -->

            </div>

			
			<div class="tips">
				<p style="font-weight:bold;font-size:20px;margin-bottom:5px;">注意：</p>
		 
				<p>收费方式：0.08元/分钟，会员0.04元/分钟。上传后需根据文件大小按照0.08/M（会员0.04/M）先支付法币押金，结果生成后，根据分钟多退少补，向上取分钟整数。使用前需要预充值哦。
					<br>非实时转换，限制文件大小500M。操作后，请过一会儿再查看记录，最快五分钟内出结果。如果超过1小时没有出结果，请咨询客服微信:dfc0829
					<br>请注意，任何产品都无法100%准确转换，转换后还请再次核对。
					<br>转换成功后，服务器保存文档一个月，超时会自动清除，请及时保存。
					<br>本功能由腾讯AI训练实现，随着训练的加深，效果会不断提升。
				</p>
		 
			</div>

			<div class="tips" style="margin-top:5px;">
				<p style="font-weight:bold;font-size:18px;margin-bottom:5px; ">生成结果样例：</p>
			
			</div>
 
			<img src="https://11law.lawtip.cn/images/sound2txt_demo.png" alt="" style="width:80%">
			
		</div>
    </div>
</template>

<script>

function sendHeight() {
	const height = document.body.scrollHeight;

	// 向父页面发送消息，包含 iframe 的高度
	window.parent.postMessage({ type: 'resize', height: height }, 'https://www.lawtip.cn');  
}




function isphone() {
	var sUserAgent = navigator.userAgent.toLowerCase();
	var bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
	var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
	var bIsMidp = sUserAgent.match(/midp/i) == "midp";
	var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
	var bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
	var bIsAndroid = sUserAgent.match(/android/i) == "android";
	var bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
	var bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
	if (bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid
			|| bIsCE || bIsWM) {
		return true
	} else {
		return false
	}
}


function guid2() {  //
    function S4() {
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    }
    return (S4() + S4()  + S4()  + S4() +  S4() +  S4() + S4() + S4());
}
// var timestamp=new Date().getTime();
 
function random_str(number){
  return Math.random().toString(36).substr(2).slice(1,number+1)
}




// const imageUpload = param => {
//     const url = 'https://lawassist.oss-cn-hangzhou.aliyuncs.com'
//     // 根据后台需求的数据格式确定headers
//     return axios.post('https://lawassist.oss-cn-hangzhou.aliyuncs.com', params, { 
//         headers: {"content-type": "multipart/form-data"}
//     })
// }


// import BreadCrumb from '@/components/BreadCrumb.vue'
// import Header from '@/components/header.vue'
// import FunctionList from '@/components/FunctionList.vue'
// import VueRouter from 'vue-router' 

// function timestampToTime(timestamp) {
//   var date = new Date(timestamp );//时间戳为10位需*1000，时间戳为13位的话不需乘1000
//   var Y = date.getFullYear() + '-';
//   var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
//   var D = date.getDate() + ' ';

 
 
 import { IncUseNumber } from '@/assets/js/cal/cal';  
import Pages from '@/components/Pages.vue'
export default {
  name: 'Home',
	metaInfo: {
		title: '录音转文字', // set a title
		meta: [{                 // set meta
			name: 'keywords',
			content: '语音转文字,律师工具,录音证据转写,语音转写'
		}],

	},
//   router,
   data() {
		return {
			scen_type:0,
			model_label:'大模型引擎（电话）',
			modelTypes1:[ 
				{label:'大模型引擎（电话）' ,value:"8k_zh_large" ,desc:"同时支持中文、多种中文方言。模型参数量极大，语言模型性能增强，针对电话音频中各类场景、各类中文方言的识别准确率极大提升。除普通话外支持27种方言（上海话、四川话、武汉话、贵阳话、昆明话、西安话、郑州话、太原话、兰州话、银川话、西宁话、南京话、合肥话、南昌话、长沙话、苏州话、杭州话、济南话、天津话、石家庄话、黑龙江话、吉林话、辽宁话、闽南语、客家话、粤语、南宁话）"  }, 
				{label:'英文电话通讯' ,value:"8k_en"  ,desc:"英文"},
	
			],
			modelTypes2:[ 
				{label:'大模型引擎（通用）' ,value:"16k_zh_large" ,desc:"当前模型同时支持中文、英文、多种中文方言等语言的识别，模型参数量极大，语言模型性能增强，针对噪声大、回音大、人声小、人声远等低质量音频的识别准确率极大提升。除普通话外支持27种方言（上海话、四川话、武汉话、贵阳话、昆明话、西安话、郑州话、太原话、兰州话、银川话、西宁话、南京话、合肥话、南昌话、长沙话、苏州话、杭州话、济南话、天津话、石家庄话、黑龙江话、吉林话、辽宁话、闽南语、客家话、粤语、南宁话）"  }, 
	 
				{label:'日语' ,value:"16k_ja" ,desc:'日语'},
				{label:'韩语' ,value:"16k_ko" ,desc:'韩语'},
				{label:'越南语' ,value:"16k_vi" ,desc:'越南语'},
				{label:'马来语' ,value:"16k_ms" ,desc:'马来语'},
				{label:'印度尼西亚语' ,value:"16k_id" ,desc:'印度尼西亚语'},
				{label:'菲律宾语' ,value:"16k_fil" ,desc:'菲律宾语'},
				{label:'泰语' ,value:"16k_th" ,desc:'泰语'},
				{label:'葡萄牙语' ,value:"16k_pt" ,desc:'葡萄牙语'},
				{label:'土耳其语' ,value:"16k_tr" ,desc:'土耳其语'},
				{label:'阿拉伯语' ,value:"16k_ar" ,desc:'阿拉伯语'},
				{label:'西班牙语' ,value:"16k_es" ,desc:'西班牙语'},
				{label:'印地语' ,value:"16k_hi" ,desc:'印地语'},
				{label:'法语' ,value:"16k_fr" ,desc:'法语'},
				{label:'德语' ,value:"16k_de" ,desc:'德语'},

			],



			pageId:'1',
			screenWidth:window.innerWidth,
			screenHeight:window.innerHeight,
            isPhone:false,
            islogin:false,
			loginInfo:{"isLogin":false ,"nickName":'' },
			SpeakerDiarization: '0',
			numbers:[2,3,4,5,6],
			SpeakerNumber:2,
			uploadData:{
				'whattodo':"upLoadFiles"
			},
			file_list:[],
			process_list:[],
			myCoins:'0',
			mypages:0,
			list:[],
			showHistroy:false,
			osspath:'',
			limit:0,
			page:1,
			modelType:'8k_zh_large',
			// modelTypes:[
			// 	{label:'电话场景：中文普通话通用' ,value:"8k_zh" }, 
			// 	{label:'中文普通话通用' ,value:"16k_zh" },  // 
			// 	{label:'电话场景：英文' ,value:"8k_en" },
			// 	{label:'英文' ,value:"16k_en" },
			// 	{label:'粤语' ,value:"16k_ca" },
			// 	{label:'日语' ,value:"16k_ja" },
			// 	{label:'其他方言' ,value:"16k_zh_dialect" }, //16k_wuu-SH 上海话方言


			
			// ],
			fileName:'',
			uploadPercent:0,
			totalRecord:0,
			task_dic:{},
			taskDialogVisible:false,
			task_downloadlink:'',
			token:'',
			uploadSig:false, //是否有文件上传的标志，1为有，0为无
		}
	},
	created(){

		this.isPhone=isphone()


	},
	mounted() {

		window.addEventListener('load', sendHeight);
		window.addEventListener('resize', sendHeight);

		IncUseNumber('sound2txt')
		// if(!this.$store.state.islogin){
 
// 			this.$notify({
// 				title: '使用需知',
// 				message: `
// 使用前请保证已经登录，并且余额账户法币大于0。
// 收费方式：0.2法币/分钟，上传后需根据文件大小按照0.2/M先支付法币押金，结果生成后，根据分钟多退少补，向上取分钟整数。 
// 非实时转换，限制文件大小500M。操作后，请过一会儿再查看记录，最快五分钟内出结果。如果超过1小时没有出结果，请咨询客服微信:dfc0829 
// 请注意，任何产品都无法100%准确转换，转换后还请再次核对。 
// 转换成功后，服务器保存文档一个月，超时会自动清除，请及时保存。
// 				`,
// 				type: 'warning',
// 				duration: 7000,
// 				offset: 50
// 			});
	 
		// }else{
		// 	this.refresh_coins()
		// 	this.GetToken()
		// }

		this.refresh_coins()
		this.GetToken()

	 
		// var timestamp=new Date().getTime();
		// this.axios.get('/webservice/login/VisitCount.php',{
        // params: {
        //     timestamp:timestamp
        // }
        // });

	},
  components: { 
    // HelloWorld,
	
	// OftenUse,
	// FootSearch,
	Pages,

	// avatar,
	// miniProgm,
	// LoginBox,
	// LeftStatus,
	
	// BreadCrumb,
	// Header,
	// FunctionList
  },
    methods: {
		// ChangeType(data){
		// 	window.console.log('data(type):',data)

		// 	if(data==71){
		// 		this.$router.push({path:'/community'})
		// 	}else{
		// 		this.pageId=data
		// 	}
			
 
		// },
		ChangeModelType(value){
			console.log(value)
			if(value==0){
				this.modelType=this.modelTypes1[0].value
			}else if(value==1){
				this.modelType=this.modelTypes2[0].value
			}
		},
		GetToken(){ 
			// this.axios.post(url,fd,{ 
			// 	withCredentials:false,
			// 	headers: {"content-type": "multipart/form-data"}
			// }
			// ).then(function (res) {

			var that=this
			var datas= { 
				// userid: userid,
				whattodo:'web_direct_oss',
			}
			this.axios.post(this.$root.rootUrl+ 'mini_app',datas,{
				withCredentials:true,
			}
			).then(function (res) {
				// window.console.log(res)
				if(res.status==200){
					var result=res.data 
					if (result.status=='ok'){
						that.token=result.token
				 
					} 
					else if (result.status=='fail'){
						let failMsg=result.failMsg || '请先登录哦'
						// that.$message.error(failMsg);
						// const h = that.$createElement;
						// that.$notify({
						// 	title: '注意',
						// 	message: h('i', { style: 'color: teal'}, failMsg),
						// 	duration: 5000,
						// 	offset:50,
						// });
						
					} 

				}


				
			}).catch(function (error) {
				window.console.log(error);

			});



		},
	


		refresh_coins() {  //bug
			var that=this

			// console.log("this.$store.state.userInfo.userId:",this.$store.state.userInfo.userId)

			var datas= { 
				// userid: this.$store.state.userInfo.userId,
				// userid:that.$root.userInfo.userId,
				whattodo:'getCoins',
			}
			this.axios.post( this.$root.rootUrl+'pay',datas    //userinfo
			).then(function (res) {
				// window.console.log(res)
				if(res.status==200){
					var result=res.data
					// window.console.log('result:',result,'result.status:',result.status)
					if (result.status=='ok'){
						that.myCoins=result.coins
						that.$root.accountInfo.coins=result.coins

						that.$store.commit('SetNewCoins',result.coins)

					} 
					else if (result.status=='fail'){
						// that.$message('获取余额失败，请稍后再试');

						if(that.$store.state.islogin){
							that.$message('获取余额失败，请稍后再试');

						}
						
					} 

					// if(result.status=='badgate'){
					// 	that.$message({
					// 		message: '请先登录哦',
					// 		type: 'warning'
					// 	});
					// }else 

				}


				
			}).catch(function (error) {
				window.console.log(error);

			});


		},

		handleUploadProgress(event, file, fileList){
			console.log('---------------')
			console.log('res:',res)
			console.log('file:',file)
			console.log('fileList:',fileList)

			console.log('---------------')


		},

		

		handleUploadSuccess(res, file){  //没用

			// this.$notify({
			// 	title: '成功',
			// 	message: '上传成功,请稍后查看记录获取下载地址。或继续上传新文件。',
			// 	type: 'success',
			// 	duration: 7000
			// });


			// window.console.log('res:',res)
			// window.console.log('file_list:',this.file_list)
			// window.console.log('upload success file: ',file)
			const h = this.$createElement;
			var that=this
	 
            if(res.status=='ok'){
				that.$notify({
					title: '成功',
					message: '上传成功,请稍后查看记录获取下载地址。或继续上传新文件。',
					type: 'success',
					duration: 5000
				});
          
            }else if(res.status=='badgate'){
             
				that.$notify({
					title: '注意',
					message: h('i', { style: 'color: teal'}, '登录超时，请重新登录'),
					duration: 5000
				});
				this.file_list=[]
 
            }else if(res.status=='fail'){
              if(res.errCOde=='4002'){

				that.$notify({
					title: '注意',
					message: h('i', { style: 'color: teal'}, '文件过大，不超过20M。'),
					duration: 6000
				});
				this.file_list=[]
               
              }

            }


		},

		get_token_and_UpLoadFiles(val){
			console.log("===========val:",val)
			var that=this
			var datas= { 
				// userid: userid,
				whattodo:'web_direct_oss',
			}
			this.axios.post(this.$root.rootUrl+ 'mini_app',datas,{
				withCredentials:true,
			}
			).then(function (res) {
				// window.console.log(res)
				if(res.status==200){
					var result=res.data 
					if (result.status=='ok'){
						that.token=result.token
				 		that.UpLoadFilesHandle(val)
					} 
					else if (result.status=='fail'){
						let failMsg=result.failMsg || '请先登录哦'
						that.$message.error(failMsg);
					 
						
					} 

				}


				
			}).catch(function (error) {
				window.console.log(error);

			});

		},

		
		UpLoadFilesHandle(val){
			var that=this
			console.log('val1:',val)
			var file=val.file
			var filename=file.name
			// console.log("token:",token)
			var token=this.token || ''
			if(!token){
				this.get_token_and_UpLoadFiles(val)
			}


			this.osspath=token.dir+ guid2()+ file.name   //文件地址
			this.fileName=filename

			// console.log(" this.osspath:",this.osspath)
			// console.log(" this.fileName:",this.fileName)


			let fd=new FormData()
			 
			fd.append("policy",token.policy);
			fd.append("OSSAccessKeyId",token.accessid);
			fd.append("signature",token.signature);
			fd.append("key",this.osspath);
	 
			fd.append("success_action_status",'200');
			fd.append("file", file);

			// console.log("----file:",file)

			const url = 'https://lawassist.oss-cn-hangzhou.aliyuncs.com'
			this.axios.post(url,fd,{ 
				withCredentials:false,
				headers: {"content-type": "multipart/form-data"},
				onUploadProgress: function (progressEvent) { //原生获取上传进度的事件
					// console.log('progressEvent:',progressEvent)
					if (progressEvent.lengthComputable) {

						that.uploadPercent=Math.floor( 100*progressEvent.loaded/progressEvent.total)
                        //属性lengthComputable主要表明总共需要完成的工作量和已经完成的工作是否可以被测量
                        //如果lengthComputable为false，就获取不到progressEvent.total和progressEvent.loaded
                        // callback1(progressEvent);
                    }
                },
		
			},
			
			).then(function (res) {
				window.console.log(res)
				if(res.status==200){
					// var result=res.data
					that.$notify({
						title: '成功',
						message: '上传成功,点击开始转换开始转写工作。',
						type: 'success',
						duration: 7000
					});

					// that.start_tran(that.osspath)
					that.file_list.push(file)
					// console.log('=====file_list:',that.file_list)
					that.uploadSig=false
				}


				
			}).catch(function (error) {
				window.console.log(error);

			});


		 


		},

		handleRemoveFile(file, fileList){
			// this.file_list=[]
			// window.console.log('++++file:',file)
			// window.console.log('----fileList:',fileList)
			if(this.file_list.length>0 && file.uid==this.file_list[0].uid ){  //删除的是文件列表中的但未处理的文件
				this.file_list=[]
				this.uploadPercent=0
			}

		},


		handleUploadbefore(file){
			// window.console.log('this.article.docid:',this.article.docid)
			if(!this.$store.state.islogin){
				this.$message.error('您需要先登录才能上传哦');
			    return false
			}
			
			if(this.file_list.length>=1){
				this.$message.error('尚有未处理的文件，需要将文件删除才能再次上传');
			    return false
			}
			// console.log('-------------handleUploadbefore')

			window.console.log(file)
			var token = this.token
			// console.log("token:",token)
			let m1=1048576   //1M 的bytes

			// if(!this.$root.islogin){
            //     this.$message({
            //         message: '请先登录哦',
            //         type: 'warning'
            //     });
            //     return
            // }

            const fileType = file.type  ;
            const isLt50M = file.size < 500*1048576 ;
            if (!isLt50M){
			  this.$message.error('上传文件大小不能超过500MB!');
			  return false
			}

			let price=0.08
			if(this.$store.state.accountInfo.vip==1){
				price=0.04
			}
			
			var deposit=Math.ceil(file.size/m1)*price
			// console.log("deposit:",deposit)
			let myCoins=this.$store.state.accountInfo.conis
			// console.log('money:',this.$store.state.accountInfo.conis)

			if (myCoins<deposit) {
				this.$message.error('根据每M文件大小'+price+'法币，您需要先预留有至少'+deposit+'，请先充值哦');
				return false
			} 

            // if(!fileType){
            //   this.$message.error('不能上传目录!');
            // }

            // window.console.log(isLt50M)
            if(isLt50M  ){ //&&fileType  大小符合条件，开始上传
				// var token = this.token
				// console.log("token:",token)

              this.uploadData.filename=file.name
              // window.console.log('this.uploadData:',this.uploadData)
              this.uploadData.whattodo="upLoadFiles"
              this.uploadData.userid=this.$root.userInfo.userId
			  //   this.uploadData.id=file.uid
				// console.log("---this.uploadData---:",this.uploadData)
             //   return false

			 this.uploadSig=true
              return isLt50M  // &&fileType;
            }else{
				console.log('false')
              return false
            }
            

		},
		

		ChangeListPage(page){
			var that=this
			this.CheckHistory(page)
		 

		},


		CheckHistory(page){
			// if(!this.$root.islogin){
            //     this.$message({
            //         message: '请先登录哦',
            //         type: 'warning'
            //     });
            //     return
			// }
			var that=this
			var datas= { 
				userid: this.$root.userInfo.userId,  //this.$root.userInfo.userId,
				page:page,
				whattodo: "checkhistory"
			}
			this.axios.post(this.$root.rootUrl+'sound2txt',datas
			).then(function (res) {
				// window.console.log(res)
				if(res.status==200){
					let respond = res.data
					if (respond.status == 'ok') {
					// var data=respond.data
					that.list=respond.data
					
					if(page==1){
						that.totalRecord=respond.totalRecord
					}
					 
					// that.setData({
					// 	list:respond.data
					// })

					}
					else if (respond.status == 'noresult') {
						// that.setData({
						// 	list:[]
						// })
						that.list=[]
						that.mypages=0
					}
					else if(respond.status=='badgate'){
						that.$message({
							message: '请先登录哦',
							type: 'warning'
						});
					}


					that.showHistroy=true

				
				}
				
				
				
			}).catch(function (error) {
				window.console.log(error);
			});
		


		},

		Go2Deposit(){
 			this.$router.push({name:"deposit"})
		},




		start_tran(){
			// if(!this.$root.islogin){
            //     this.$message({
            //         message: '请先登录哦',
            //         type: 'warning'
            //     });
            //     return
			// }



			if(!this.osspath || !this.fileName){
				this.$message({
                    message: '请先上传文件',
                    type: 'warning'
                });
                return
			}
			// console.log("this.SpeakerDiarization:",this.SpeakerDiarization)
			// console.log("this.EngineModelType:",this.EngineModelType)


			// if(this.modelType!='16k_zh' && this.modelType!='8k_zh'){
			// 	this.SpeakerDiarization='0'
			// }

			console.log("this.SpeakerDiarization:",this.SpeakerDiarization)

			var that=this
			var datas= { 
				osspath: this.osspath,  //this.$root.userInfo.userId,
				whattodo: "transwork2",
				EngineModelType :this.modelType,
				SpeakerDiarization:this.SpeakerDiarization,
				SpeakerNumber:this.SpeakerNumber,
				fileName:this.fileName

			}
			this.axios.post(this.$root.rootUrl+'sound2txt',datas
			).then(function (res) {
				// window.console.log(res)
				if(res.status==200){
					let respond = res.data
					if (respond.status == 'ok') {
						that.$notify({
							title: '成功',
							message: '上传成功,转换工作非实时。稍后可在记录中看到结果，网页关闭或刷新都不影响返回，也可继续上传新文件进行转换，请勿重复上传重复文件避免浪费法币',
							type: 'success',
							duration: 7000
						});

						that.fileList=[]
						that.file_list=[]
						that.uploadPercent=0
						that.osspath=''

						let taskId=respond.taskId+''
						// that.task_dic[taskId]=
						var interval_num=0
						let obj={fileName:datas.fileName , taskId:  taskId ,isDone:0}
						that.process_list.unshift(obj)

						that.task_dic[taskId]=setInterval(()=>{
							interval_num++
							that.checkTaskStatus(taskId)
							if(interval_num>150){
								clearInterval(that.task_dic[taskId])
							}

						},6000)
						 

					}
					else if (respond.status == 'fail') {
					  that.$message({
							message: respond.failMsg,
							type: 'warning'
						});
					}
					else if(respond.status=='badgate'){
						that.$message({
							message: '请先登录哦',
							type: 'warning'
						});
					}


					that.showHistroy=true

				
				}else{
					that.$message.error('服务器错误,请等待修复或主动联系管理员');
				}
				
				
				
			}).catch(function (error) {
				window.console.log(error);
				that.$message.error('服务器错误,请等待修复或主动联系管理员');
			});
		


		},

		DownLoadTask(link){

			window.open(link,'new')
		},

		
		GMTToStr(time){
			let date = new Date(time)
			let Str=date.getFullYear() + '-' +
			(date.getMonth() + 1) + '-' +
			date.getDate() + ' ' +
			date.getHours() + ':' +
			date.getMinutes() + ':' +
			date.getSeconds()
			return Str
		},

		fermitTime(time){
			var span = Date.parse(time+'+0800')
			var dt = new Date(span)
			var timeStr = dt.getFullYear() + '-' + (dt.getMonth() + 1) + '-' + dt.getDate() + ' ' + dt.getHours() + ':' + dt.getMinutes() + ':' + dt.getSeconds()
			return timeStr
		},

		checkTaskStatus(taskId){
			var that=this
			var datas= { 
				whattodo: "checkTaskStatus",
				taskId:taskId
			}
			this.axios.post(this.$root.rootUrl+'mini_app',datas
			).then(function (res) {
				// window.console.log(res)
				if(res.status==200){
					let respond = res.data
					if (respond.status == 'ok') {
						let status=respond.isDone
						if(status){
							let downLoadLink=respond.downLoadLink
							that.$notify({
								title: '成功',
								message: '转换成功，您可以在：'+downLoadLink+'下载，也可以在记录中找到',
								type: 'success',
								duration: 3000,
								offset:50
							});

							clearInterval(that.task_dic[taskId])

							let _list=that.process_list
							let ind=_list.map(x => x.taskId).indexOf(taskId)
							if (ind!=-1){

								let obj= that.process_list[ind]
								obj.isDone=1
								obj.downLoadLink=downLoadLink
								Vue.set(that.process_list, ind, obj)
							}
							that.refresh_coins()
							// let ind=that.process_list.

						}

					}
					// else if (respond.status == 'noresult') {
					 
					// 	that.list=[]
					// 	that.mypages=0
					// }
					// else if(respond.status=='fa'){
					// 	that.$message({
					// 		message: '请先登录哦',
					// 		type: 'warning'
					// 	});
					// }


					// that.showHistroy=true

				
				}
				
				
				
			}).catch(function (error) {
				window.console.log(error);
			});





		},

		CheckItemDetail(link){
			this.task_downloadlink=link 
			this.taskDialogVisible=true

		}





        
	}
}

</script>







<style>
/* #app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  span-align: center;
  color: #2c3e50;
  margin-top: 60px;
} */
/* .el-header{
	height: 280px;
} */
/* .hearder{
	height: 280px;
} */

/* @import url(../static/css/cal.css); */

/* @import url(../assets/css/cal.css);
@import url(../assets/css/home.css); */

 

.mainbox{
	display: flex;
	flex-direction: row;
	width:100%;
	/* height: 680px; */
	/* border:1px solid rgb(190, 216, 42); */
}

.leftside{
	width:10%;
	height: 100%;
	/* display: flex;
	flex-direction: column;
	align-items:center;
	justify-content: center; */
	/* border-right:1px solid rgb(191, 194, 201); */
}
.rightside{
	height: 100%;
	/* width:90%; */
	width:100%;

	display: flex;
	flex-direction: column;
	/* align-items:center; */
	/* border:1px solid rgb(13, 126, 56); */
	margin-left: auto;
	margin-right: auto;
	
}
.rightfoot{
	display: flex;
	flex-direction: row;
	height: 10%;
	border:1px solid #3ca04a;
}

.avatar_box{
	margin-left: auto;
	margin-right:auto;
	margin-top:30px;
	width:90px;
	height:100px;
	/* border:1px solid #185c9c; */
	/* span-align:center; */
	/* justify-content: center;  */
}
.user_name{
	margin-top:5px;
	overflow: hidden;
	padding: 4px;
	
}
.el-container{
	height: 700px;
	width:1200px;
}
 .el-header {
    background-color: #ffffff;
	height: 30px;
	color: #333;
	span-align: center;
	/* line-height: 60px; */
	
  }
  .el-footer {
	background-color: #B3C0D1;
	span-align: center;
	line-height: 60px;
	color: #333;
	
	display: flex;
	flex-direction: row;
	/* align-items:center; */
   }


  
  .el-aside {
    background-color: #D3DCE6;
    color: #333;
    span-align: center;
	/* eight: 100%; */
    /* line-height: 200px; */
	/* height: 100%; */
  }
  
  .el-main {
    background-color: #E9EEF3;
    color: #333;
    span-align: center;
    line-height: 160px;
	height: 100%;
  }
  
  body > .el-container {
    margin-bottom: 40px;
  }
  
  .el-container:nth-child(5) .el-aside,
  .el-container:nth-child(6) .el-aside {
    line-height: 260px;
  }
  
  .el-container:nth-child(7) .el-aside {
    line-height: 320px;
  }

.InnerBox{
	width:100%;
	/* height: 85%; */
	/* border:1px solid #d808d8; */
	display: flex;
	flex-direction: column;
	overflow-y:scroll;
}
.beian{
	/* border:1px solid #5a96cf; */
	span-align:center;
	font-size:12px;
	display: flex;
	flex-direction: column;
}



.mine{
	width:150px;
	height:40px;
	display: flex;
	flex-direction: row;
	align-items:center;
	position: fixed ;
	/* border:1px solid #d808d8; */
	bottom:10px;
	right:10px;
	font-size:25px;
	opacity: 0.5;
}

.msgCenter{
	/* min-width:400px;
	min-height: 600px; */

	width:100%;
    height:360px;
	overflow-y: scroll;
	display: flex;
	flex-direction: column;
}

 
/* .scroll-x{
    white-space:nowrap;
    display:flex;
    flex-direction: column;
    font-size:0;
} */

.div-parent{
   /* display:inline-block; */
   /* background:#cceeff; */
   background:#f1f0f0;
   display: flex;
   flex-direction: row;
   justify-content: flex-start;
   /* width:1200px; */
    border:1px solid #222;

    /* white-space: normal; 
    word-wrap: break-word; */
   overflow: hidden;
}

.div-item-title{
    width:100px;
    height:40px;
    display:flex;
 
    /* flex-direction: column; */
    align-items:center;
    justify-content:center;
    font-size:14px;
    color:#222;
    /* background:#cceeff; */
    /* margin:4px; */
    margin-left:20px;
    border:1px solid #222;
    white-space: normal;
    word-wrap: break-word;
    span-overflow:ellipsis;
    /* height:70px; */
    word-break:break-all;

}


.list_detail{
    display:flex;
    flex-direction:row;
	/* width: 1050px; */
	width:100%;
	align-items:center;
    /* border:1px solid #222; */
	
  
  
}

.list_detail2{
    display:flex;
    flex-direction:row;
    background-color:  #f1eeee;
	/* width: 1050px; */
	width:100%;
	align-items:center;
    /* border:1px solid #222; */
	
  
}



.detail_n{
 
    flex-shrink: 0;
    /* width:160px; */
    width:150px;
    /* height:100px; */

    display:flex;
    /* flex-direction: column; */

    align-items:center;
    justify-content:center;
    font-size:18px;
    /* line-height: 50px; */
    height:50px;
    color:#222;
    /* margin-left:30px; */
    margin-left:20px;
    /* border:1px solid #222; */
    white-space: normal;
    word-wrap: break-word;
    span-overflow:ellipsis;
    word-break:break-all;

}
.detail_n img{
  width:40px;
  height: 40px;
  border-radius: 15px;
}
.detail_n  el-button{
  width:112px;
  height: 22px;
  margin:auto;
  font-size:16px;
  line-height: 22px;
} 
.noticeRow{
	flex-shrink: 0;
	min-height: 50px;
	font-size:18px;
	display: flex;
	justify-content: flex-start;
	align-items: center;
	white-space: normal;
    word-wrap: break-word;
    span-overflow:ellipsis;
    word-break:break-all;

}

.upload-demo{
	margin-top:30px;
	padding: 6px;
	/* border:1px solid #222; */
	display: flex;
	flex-direction: column;

	justify-content: center;
	align-items: center;
}
.el-upload__tip{
	word-wrap:break-word;
	word-break:normal;
}

.tips{
	margin-top:80px;
	width:100%;
	/* border:1px solid #222; */
	font-size:12px;
	line-height: 20px;
	display: flex;
	display: flex;
	flex-direction: column;
}
.tips span{
	width:40%;
	/* min-height: ; */
	border:1px solid #222;
	word-wrap:break-word;
	word-break:normal;
	/* float:right; */
}

.history_button{
  width:100%;
  margin-top:30px;
  height: 40px;
  line-height: 40px;
  /* height: 60px; */
  /* float: right; */
  /* border:3px solid #1d495c; */
  /* display: flex;
  flex-direction: row;
  align-items: center; */

}

.history_bar{
  margin-top:25px;
  width:100%;
  height:30px;
  line-height: 30px;
  background-color: #cfd8dc;
  /* border:3rpx solid #cfd8dc; */
}

.reuslt_bar{
  width:100%;
  min-height:30px;
  max-height: 60px;
  /* height: 60rpx; */
  display: flex;
  flex-direction: row;
  line-height: 30px;
  /* flex-wrap: wrap; */
   
}

.res_item{
  border:1px solid #cfd8dc;
  text-align: center;
  overflow: hidden;
  word-wrap:break-word;
  word-break:normal; 
  padding: 0 2px 0 2px;
}

.bottom{
    display: flex;
    flex-direction: row;
    width:100%;
    height: 30px;
    line-height: 30px;
    margin-top:14px;
    /* border:1px solid #50b66f;  */
	font-size:13px;
	justify-content: flex-end;
	/* padding-right: 0; */
	
}
.bottom.left{
    width:65%;
    /* border:1px solid #953ba7;  */
    padding-left: 14px;
}
.bottom.right{
	width:50%;
	/* float:right; */
    /* border:1px solid #c9c62e;  */

}

.Generate{
	margin-top:100px;
	width:240px;
}



.upload_wrap{
	display: flex;
	flex-direction: row;
	width:85%;
	border:1px dashed #d4d4d4; 
	padding-bottom: 5px;
	margin-top: 15px;


}

.upload_wrap .left_box,.right_box{
	display: flex;
	flex-direction: column;
	align-items: center;
	/* border:1px solid #31b831;  */
	width:50%;
	padding-bottom: 30px;
 
}
 
.upload_wrap .left_box{
	/* max-height: 100%; */
	padding-left:5px ;
	overflow-y: scroll;
} 


.hidden_img{
    position: fixed;
    top:100px;
    z-index: -1;
    max-width: 950px;
    height: auto;
}



.fangyan{
	width: 60%;
	font-size:14px;
	color: rgb(150, 149, 149);


}



.guide{
  /* font-size:22rpx; */
  float: right;
  /* padding-right: 20rpx; */
  /* text-decoration: underline; */
  margin-right: 20px;
  color: rgb(211, 94, 27); 
  cursor: pointer;
}
</style>
